import { type ReactNode } from 'react';
import { useMouseParallax } from '@/hooks/use-mouse-parallax';

type OrbDef = {
  cx: string;
  cy: string;
  r: number;
  color: string;
  opacity: number;
  delay: string;
};

const ORBS: OrbDef[] = [
  {
    cx: '50%',
    cy: '45%',
    r: 280,
    color: '#ff4444',
    opacity: 0.18,
    delay: '0s',
  },
  {
    cx: '44%',
    cy: '50%',
    r: 200,
    color: '#ff7777',
    opacity: 0.12,
    delay: '-4s',
  },
  {
    cx: '56%',
    cy: '42%',
    r: 160,
    color: '#ff2222',
    opacity: 0.08,
    delay: '-8s',
  },
];

export function GlowOrb(): ReactNode {
  const { x, y } = useMouseParallax(0.015);
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      <div
        className="absolute inset-0"
        style={{ transform: `translate(${x}px, ${y}px)` }}
      >
        {ORBS.map((o) => (
          <Orb key={o.cx} {...o} />
        ))}
      </div>
      <div className="absolute inset-0 backdrop-blur-[100px]" />
    </div>
  );
}

function Orb({ cx, cy, r, color, opacity, delay }: OrbDef): ReactNode {
  const size = `${r * 2}px`;
  return (
    <div
      className="absolute rounded-full animate-orb-drift"
      style={{
        width: size,
        height: size,
        left: cx,
        top: cy,
        transform: 'translate(-50%, -50%)',
        background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        opacity,
        animationDelay: delay,
      }}
    />
  );
}
